import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main/main.component";
import { NewsComponent } from "./main/news/news.component";
import { OrganizationsComponent } from "./main/organizations/organizations.component";
import { CompetitionsComponent } from "./main/competitions/competitions.component";
import { MainCouncilComponent } from "./council/main-council/main-council.component";
import { NationalityCouncilComponent } from "./council/nationality-council/nationality-council.component";
import { CommonDatasComponent } from "./common-datas/common-datas.component";
import { ContactsComponent } from "./contacts/contacts.component";
import { ElectionComponent } from "./election/election.component";
import { SightsComponent } from "./sights/sights.component";
import { DocumentsComponent } from "./council/main-council/documents/documents.component";
import { MainTasksComponent } from "./council/main-council/main-tasks/main-tasks.component";
import { OfficersComponent } from "./council/main-council/officers/officers.component";
import { SecondedComponent } from "./council/main-council/seconded/seconded.component";
import { CouncilInformationsComponent } from "./council/main-council/council-information/council-information.component";
import { NoDataComponent } from "./no-data/no-data.component";
import { HvbComponent } from "./hvb/hvb.component";
import { PrivacyComponent } from "./privacy/privacy.component";
import { AdministrationComponent } from "./main/administration/administration.component";
import { CommunityComponent } from "./main/community/community.component";
import { Election2024Component } from "./election-2024/election-2024.component";
import { ElectionDetailsComponent } from "./election-details/election-details.component";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    children: [
      { path: "news", component: NewsComponent, data: { animation: "News" } },
      {
        path: "organizations",
        component: OrganizationsComponent,
        data: { animation: "Organizations" },
      },
      {
        path: "competitions",
        component: CompetitionsComponent,
        data: { animation: "Competitions" },
      },
      {
        path: "administration",
        component: AdministrationComponent,
        data: { animation: "Administration" },
      },
      {
        path: "community",
        component: CommunityComponent,
        data: { animation: "Community" },
      },
      { path: "", redirectTo: "/main/news", pathMatch: "full" },
      { path: "**", redirectTo: "/main/news" },
    ],
  },
  {
    path: "main-council",
    component: MainCouncilComponent,
    children: [
      {
        path: "documents/:opened",
        component: DocumentsComponent,
        data: { animation: "Documents" },
      },
      {
        path: "documents",
        component: DocumentsComponent,
        data: { animation: "Documents" },
      },
      {
        path: "main-tasks",
        component: MainTasksComponent,
        data: { animation: "MainTasks" },
      },
      {
        path: "officers",
        component: OfficersComponent,
        data: { animation: "Officers" },
      },
      {
        path: "seconded",
        component: SecondedComponent,
        data: { animation: "Seconded" },
      },
      {
        path: "council-information",
        component: CouncilInformationsComponent,
        data: { animation: "CouncilInformations" },
      },
      {
        path: "",
        redirectTo: "/main-council/main-tasks",
        pathMatch: "full",
      },
      { path: "**", redirectTo: "/main-council/main-tasks" },
    ],
  },
  {
    path: "nationality-council",
    component: NationalityCouncilComponent,
  },
  {
    path: "common-datas",
    component: CommonDatasComponent,
  },
  {
    path: "contacts",
    component: ContactsComponent,
  },
  {
    path: "election",
    component: ElectionComponent,
  },
  {
    path: "hvb",
    component: HvbComponent,
  },
  {
    path: "election-2024",
    component: Election2024Component,
  },
  {
    path: "election-details",
    component: ElectionDetailsComponent,
  },
  {
    path: "sights",
    component: SightsComponent,
  },
  {
    path: "privacy",
    component: PrivacyComponent,
  },
  {
    path: "no-data",
    component: NoDataComponent,
  },
  {
    path: "",
    redirectTo: "/main/news",
    pathMatch: "full",
  },
  { path: "**", redirectTo: "/main/news" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
